import React, { useContext, useState, useEffect } from 'react';

import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import { AppSettings } from '../../config/app-settings.js';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import adminService from '../../services/AdminService/admin-service.js';
import coalService from '../../services/CoalService/coal-service.js';
import LetterSelector from '../../components/taxonomy/letter-selector.jsx';
import TaxonGenus from '../../components/taxonomy/taxon-genus.jsx';
import PageHeaderFixed from '../../components/page-header/page-header-fixed.jsx';
import useGroupedByLetter from '../../hooks/useGroupedByLetter.js';
import PaginationControls from '../../components/pagination/PaginationControls.jsx';
import usePagination from '../../hooks/usePagination.js';

const PAGE_SIZE = 33;

export default function BuscaTaxGen(props){
    const history = useHistory();
    const { user, ...settings } = useContext(AppSettings);
    const { t, i18n } = useTranslation();
    const { tabList, activeLetter, setActiveLetter } = useGroupedByLetter(adminService.listActiveGenus, i18n.language);

    // bloco de paginação
    const currentGen = activeLetter ? (tabList[activeLetter] || []) : [];
    const { currentPage, totalPages, paginatedItems: currentGenera, changePage, resetPage } = usePagination(currentGen, PAGE_SIZE);
    
    const changeLetter = (letter) => {
        setActiveLetter(letter);
        resetPage();
    }
    // fim do bloco de paginação

    const searchForCoals = (type, payload) => {
        if (type === 'record') {
            const resp = [[payload, 'null']];
            history.push({ pathname: '/pesquisa-resultado', state: { coals: resp }, from: '/taxonomia/genero' });
            return;
        }
        
        const request = { public: !user };
        const serviceCall = {
            genus:  () => coalService.filterCoalByGenus({ ...request, genus_id: payload }),
            species: () => coalService.filterCoalBySpecies({ ...request, species_id: payload }),
        }[type];

        serviceCall().then(response => {
            if(response.data.length === 0){
                settings.handleSetAlert('info', '', t('carvão.pesquisa.modal.semResult'));
            }else{
                const resp = response.data.map(c => [c, 'null']); // formata os resultados no padrão esperado pela tela de resultados
                history.push({pathname: '/pesquisa-resultado', state: {coals : resp}, from: '/taxonomia/genero'});
            }
        }).catch(()=>{
            settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('alerta.algoDeuErrado.mensagem'));
        }) 
    }

    return(
        <>
            <PageHeaderFixed title={t('carvão.buscaPorTaxon.tituloGenero')}>
                <div className='col'>
                    {Object.keys(tabList).length === 0 && (
                        <div className="fa-3x carregando-pagina">
                            <i className="fas fa-spinner fa-pulse"></i>
                        </div>
                    )}
                    {Object.keys(tabList).length > 0 && (
                        <Panel> 
                            <PanelHeader noButton={true}>
                                <div className="d-flex flex-row flex-wrap align-items-center justify-content-between w-100 gap-1 py-1">
                                    <LetterSelector
                                        tabList={tabList}
                                        activeLetter={activeLetter}
                                        onSelect={changeLetter}
                                    />
                                    <PaginationControls
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onChangePage={changePage}
                                    />
                                </div>
                            </PanelHeader>
                            <PanelBody>
                                {currentGenera.map(g => (
                                    <TaxonGenus
                                        key={g.id}
                                        genus={g}
                                        onNavigate={searchForCoals}
                                        settings={settings}
                                        t={t}
                                    />
                                ))}
                            </PanelBody>
                        </Panel>
                    )}
                </div>
            </PageHeaderFixed>
        </>
    )
}